import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';

interface OnSIIconProps {
  cssClasses?: string;
}

export default component$(({ cssClasses }: OnSIIconProps): JSX.Element => {
  return (
    <svg
      class={cssClasses}
      xmlns='http://www.w3.org/2000/svg'
      width='93'
      height='22'
      viewBox='0 0 93 22'
      fill='none'
    >
      <g clip-path='url(#clip0_2619_11123)'>
        <path
          d='M20.0702 12.5839C20.0702 14.6118 19.9924 16.0534 19.8369 16.8969C19.6813 17.7404 19.1968 18.512 18.3832 19.2119C17.5697 19.9118 16.469 20.4442 15.0812 20.8211C13.6933 21.1979 12.0782 21.3834 10.2358 21.3834C8.39331 21.3834 6.91575 21.2039 5.52195 20.851C4.12815 20.4981 3.00951 19.9657 2.16007 19.2598C1.31063 18.5539 0.808142 17.7822 0.646629 16.9507C0.485115 16.1192 0.401367 14.6656 0.401367 12.5839V9.12629C0.401367 7.0984 0.479133 5.66272 0.634665 4.81328C0.790196 3.96981 1.27474 3.19814 2.08829 2.49825C2.90184 1.79835 4.00253 1.26595 5.39035 0.889089C6.77817 0.512224 8.39331 0.326782 10.2358 0.326782C11.9825 0.326782 13.5558 0.506242 14.9496 0.859179C16.3434 1.21212 17.462 1.74451 18.3114 2.45039C19.1609 3.15626 19.6634 3.92794 19.8249 4.75944C19.9864 5.59093 20.0702 7.04456 20.0702 9.12629V12.5839ZM11.5697 5.94387C11.5697 5.0047 11.486 4.40052 11.3185 4.14329C11.151 3.88008 10.804 3.74848 10.2776 3.74848C9.83497 3.74848 9.49399 3.85616 9.26069 4.06553C9.0274 4.2749 8.90776 4.90301 8.90776 5.94387V15.3775C8.90776 16.5499 8.98552 17.2738 9.14105 17.5489C9.29659 17.8241 9.65551 17.9617 10.2238 17.9617C10.7921 17.9617 11.1749 17.8062 11.3364 17.4891C11.498 17.1721 11.5817 16.4183 11.5817 15.2279V5.94387H11.5697Z'
          fill='white'
        />
        <path
          d='M40.5619 0.757568V20.9587H33.1084L28.6877 11.7764V20.9587H21.5811V0.757568H28.6877L33.4553 9.85019V0.757568H40.5619Z'
          fill='white'
        />
        <path
          d='M84.0731 0.949138H92.4676V20.7603H84.0731V0.949138ZM82.4552 15.3267V14.2339C82.4552 10.8883 80.5138 9.50243 74.4331 8.17762C72.6137 7.77468 71.9239 7.37174 71.9239 6.15682V5.40588C71.9239 4.832 72.4245 4.53896 72.8641 4.53896C73.4929 4.53896 73.8042 4.9419 73.8042 5.40588V7.76857H82.1439V6.32776C82.1439 2.40826 80.2024 0.33252 72.4245 0.33252C66.7833 0.33252 62.583 2.17627 62.583 6.27281V7.02375C62.583 10.6014 64.2741 12.2131 70.6052 13.6539C72.6137 14.1179 73.3036 14.1729 73.3036 15.4427V16.1937C73.3036 16.9446 73.1144 17.2315 72.3634 17.2315C71.4843 17.2315 71.4232 16.7126 71.4232 16.1387V14.179H62.583V15.1008C62.583 19.9422 65.5318 21.3891 72.6137 21.3891C79.3233 21.3891 82.4552 20.0643 82.4552 15.3328'
          fill='white'
        />
        <path
          d='M55.7828 5.56628C53.4597 3.04627 49.6895 3.04627 47.3664 5.56628C45.0432 8.08628 45.0432 12.1616 47.3664 14.6718L51.5795 19.2294L55.7926 14.6718C58.1158 12.1518 58.1158 8.07644 55.7926 5.56628H55.7828ZM51.5697 12.5849C50.3195 12.5849 49.3154 11.4922 49.3154 10.1436C49.3154 8.79504 50.3293 7.70238 51.5697 7.70238C52.81 7.70238 53.8239 8.79504 53.8239 10.1436C53.8239 11.4922 52.81 12.5849 51.5697 12.5849Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_2619_11123'>
          <rect
            width='93'
            height='21.6415'
            fill='white'
            transform='translate(0 0.0933838)'
          />
        </clipPath>
      </defs>
    </svg>
  );
});
